import ActionError from './action-error';

export default class RuntimeError extends Error implements ActionError {}
